var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Row from "reactstrap/lib/Row";
import Col from "reactstrap/lib/Col";
import classNames from "classnames";
// import Icon from "../../../components/Library/Icon/Icon";
import * as userSettingsActions from "../../actions/userSettings";

import DeleteAccount from "./DeleteAccount";
import ChangePassword from "./ChangePassword";
import toggleScroll from "../../../utils/toggleScroll";

import styles from "./UserSettings.css";

var ProfileSettings = function (_Component) {
  _inherits(ProfileSettings, _Component);

  function ProfileSettings() {
    _classCallCheck(this, ProfileSettings);

    var _this = _possibleConstructorReturn(this, (ProfileSettings.__proto__ || Object.getPrototypeOf(ProfileSettings)).call(this));

    _this.state = {
      showDeleteAccount: false
    };

    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);

    _this.toggleDeleteAccount = _this.toggleDeleteAccount.bind(_this);
    _this.toggleChangePassword = _this.toggleChangePassword.bind(_this);
    return _this;
  }

  _createClass(ProfileSettings, [{
    key: "handleChange",
    value: function handleChange(event) {
      this.props.userSettingsActions.typingUserSettings(_defineProperty({}, event.target.name, event.target.value));
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit() {
      this.props.userSettingsActions.submitUserSettings(this.props.userSettings.data.profileInfo);
    }
  }, {
    key: "toggleDeleteAccount",
    value: function toggleDeleteAccount() {
      toggleScroll();
      this.setState({ showDeleteAccount: !this.state.showDeleteAccount });
    }
  }, {
    key: "toggleChangePassword",
    value: function toggleChangePassword() {
      toggleScroll();
      this.setState({ showChangePassword: !this.state.showChangePassword });
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(
        "div",
        { className: styles.infoWrapper },
        this.state.showDeleteAccount ? React.createElement(DeleteAccount, { toggleDeleteAccount: this.toggleDeleteAccount }) : null,
        this.state.showChangePassword ? React.createElement(ChangePassword, { toggleChangePassword: this.toggleChangePassword }) : null,
        React.createElement(
          "div",
          { className: styles.blueHeading },
          "PROFILE"
        ),
        React.createElement(
          Row,
          { className: styles.marginTop20 },
          React.createElement(
            Col,
            { lg: "2", sm: "12", xs: "12", className: styles.muted },
            "FIRST NAME"
          ),
          React.createElement(
            Col,
            { lg: "10", sm: "12", xs: "12" },
            React.createElement("input", { "aria-label": "First name", onChange: this.handleChange, name: "first_name", type: "text", className: styles.bottomLineInputs, value: this.props.userSettings.data.profileInfo.first_name })
          )
        ),
        React.createElement(
          Row,
          { className: styles.marginTop20 },
          React.createElement(
            Col,
            { lg: "2", sm: "12", xs: "12", className: styles.muted },
            "LAST NAME"
          ),
          React.createElement(
            Col,
            { lg: "10", sm: "12", xs: "12" },
            React.createElement("input", { "aria-label": "Last Name", onChange: this.handleChange, name: "last_name", type: "text", className: styles.bottomLineInputs, value: this.props.userSettings.data.profileInfo.last_name })
          )
        ),
        React.createElement(
          Row,
          { className: styles.marginTop20 },
          React.createElement(
            Col,
            { lg: "2", sm: "12", xs: "12", className: styles.muted },
            "EMAIL"
          ),
          React.createElement(
            Col,
            { lg: "10", sm: "12", xs: "12" },
            React.createElement("input", { "aria-label": "Email", onChange: this.handleChange, name: "email", type: "email", className: styles.bottomLineInputs, value: this.props.userSettings.data.profileInfo.email })
          )
        ),
        React.createElement(
          Row,
          { className: styles.marginTop20 },
          React.createElement(
            Col,
            { lg: "2", sm: "12", xs: "12", className: styles.muted },
            "JOB TITLE"
          ),
          React.createElement(
            Col,
            { lg: "10", sm: "12", xs: "12" },
            React.createElement("input", { "aria-label": "Job Title", onChange: this.handleChange, name: "job_title", type: "text", className: styles.bottomLineInputs, value: this.props.userSettings.data.profileInfo.job_title })
          )
        ),
        React.createElement(
          Row,
          { className: styles.marginTop20 },
          React.createElement(
            Col,
            { lg: "2", sm: "12", xs: "12", className: styles.muted },
            "INDUSTRY"
          ),
          React.createElement(
            Col,
            { lg: "10", sm: "12", xs: "12" },
            React.createElement("input", { "aria-label": "Industry", onChange: this.handleChange, name: "industry", type: "text", className: styles.bottomLineInputs, value: this.props.userSettings.data.profileInfo.industry })
          )
        ),
        React.createElement(
          "div",
          { className: styles.marginTop40 },
          React.createElement(
            "button",
            { onClick: this.toggleChangePassword, className: classNames(styles.grayButton1, styles.mobileBlock) },
            "Change your password"
          ),
          React.createElement(
            "button",
            { onClick: this.toggleDeleteAccount, type: "button", className: classNames(styles.grayButton1, styles.mobileBlock, styles.deleteAccountButton) },
            "Delete your account"
          )
        ),
        React.createElement(
          "div",
          { className: styles.textCenter },
          React.createElement(
            "button",
            { onClick: this.handleSubmit, type: "button", className: classNames(styles.blueButton1, styles.mobileBlock, styles.saveProfileChangesButton) },
            "Save changes"
          )
        )
      );
    }
  }]);

  return ProfileSettings;
}(Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    userSettings: state.userSettings
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    userSettingsActions: bindActionCreators(userSettingsActions, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProfileSettings);


// WEBPACK FOOTER //
// ./src/users/components/UserSettings/ProfileSettings.js